import type { IconSvgObject } from './types';

const MaximizeScreenIcon: IconSvgObject = [
  ["path", { d: "M22 9.5V14.5M5.5 2H4C2.89543 2 2 2.89543 2 4V5.5M18.5 2H20C21.1046 2 22 2.89543 22 4V5.5M18.5 22H20C21.1046 22 22 21.1046 22 20V18.5M9.5 2H14.5M2 9.5V11M14.4999 21.9999H12.9999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 15C10 14.4477 9.55228 14 9 14H3C2.44772 14 2 14.4477 2 15V21C2 21.5523 2.44772 22 3 22H9C9.55228 22 10 21.5523 10 21V15Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 14L14.4425 9.55753M11.475 9H15V12.4599", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MaximizeScreenIcon;
